import React from "react";
import { ReactComponent as ImageBackground } from "../../../assets/icons/image-background.svg";
import KEYWORDS from "../../../assets/images/KEYWORDS.png";
import TOPIC_COMPARISON from "../../../assets/images/TOPIC_COMPARISON.png"
import SAMPLE from "../../../assets/images/SAMPLE.png"
import EXTENDED_ANALYTIC from "../../../assets/images/EXTENDED_ANALYTIC.png"
import REPORTS from "../../../assets/images/REPORTS.png"
import DASHBOARDS from "../../../assets/images/DASHBOARDS.png"
import NOTIFICATIONS from "../../../assets/images/NOTIFICATIONS.png"
import SocialNetBlock from "pages/landing-page/items/socnet_blocks/socnet-block";

import s from "./demo-page.module.scss";

const DemoPage = (props) => {

    const createMarkup = (text) => {
        return {__html: text};
    }

    const notification = <div className={s.NotificationBlock}>
                            <div className={s.Notification}>
                                <SocialNetBlock getValue={props.getValue} name={'TELEGRAM_2'}/>
                            </div>
                            <div className={s.Notification}>
                                <SocialNetBlock getValue={props.getValue} name={'MAIL'}/>
                            </div>       
                        </div>
    

    const getImageByImageText = (imageText) => {
        switch(imageText){
            case 'TOPICS_AND_KEYWORDS':
                return <img src={KEYWORDS} />;
            case 'TOPIC_COMPARISON':
                return <img src={TOPIC_COMPARISON} />;
            case 'SAMPLE':
                return <img src={SAMPLE} />;
            case 'EXTENDED_ANALYTIC':
                return <img src={EXTENDED_ANALYTIC} />;
            case 'REPORTS':
                return <img src={REPORTS} />;
            case 'DASHBOARDS':
                return <img src={DASHBOARDS} />;
            case 'NOTIFICATIONS':
                return notification;
        }
    }

    return (
        <div id={props.content.name} className={s.DemoPage}>
            <div className={s.content}>
                <div className={s.title}>
                    { props.getValue(props.content.title) }
                </div>
                <div className={s.textBlock} style={{textTransform: 'uppercase'}}>
                    { props.getValue(props.content.description) }
                </div>
                <div className={s.textBlock} dangerouslySetInnerHTML={createMarkup(props.getValue(props.content.text)) }>
                    
                </div>
            </div>
            <div className={s.demoImage}>
               {getImageByImageText(props.content.title)}
            </div>
        </div>
    )
}

export default DemoPage;